/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable no-param-reassign */
/* eslint-disable no-bitwise */

export function getOffset(Node: any, offset?: any) {
  if (!offset) {
    offset = {};
    offset.top = 0;
    offset.left = 0;
  }
  if (Node === document.body || !Node) {
    // 当该节点为body节点时，结束递归
    return offset;
  }
  offset.top += Node.offsetTop;
  offset.left += Node.offsetLeft;
  return getOffset(Node.offsetParent, offset); // 向上累加offset里的值
}

/**
 * 构建给定字符串的 hash 值
 *
 * @example
 * hashNumber('天气');
 * // returns 1234;
 */
export const hashNumber = (str: string): number => {
  let hash = 0;
  let i;
  let chr;
  if (str.length === 0) {
    return hash;
  }
  for (i = 0; i < str.length; i++) {
    chr = str.charCodeAt(i) + Math.floor(Math.random() * 50);
    hash = (hash << 5) - hash + chr;
    hash |= 0; // Convert to 32bit integer
  }
  return hash;
};
